import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { SetShippingLineOrderInput } from './SetShippingLineOrderInput';
import { SetShippingLineOrderOutput } from './SetShippingLineOrderOutput';

export class SetShippingLineOrderService extends HttpServiceBase {

  handle = (input: SetShippingLineOrderInput): Promise<Result<SetShippingLineOrderOutput> | null> => {
    const promise = this.http.post<Result<SetShippingLineOrderOutput>, SetShippingLineOrderInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/shipping-line`,
      input
    );
    return promise;
  }
}